import { useConfigCat } from "../../services/featureFlagProvider";
import { FlagsStatus } from "../../utils/configCatUtils";

export function FeatureFlagsTab() {
  const flagState = useConfigCat();

  if (!flagState) {
    return null;
  }

  const { flagValues, status } = flagState;

  // Truncate long values for display
  const formatValue = (value: unknown): string => {
    const stringValue =
      typeof value === "object" ? JSON.stringify(value) : String(value);
    return stringValue.length > 50
      ? `${stringValue.substring(0, 47)}...`
      : stringValue;
  };

  // Get status color
  const getStatusColor = () => {
    switch (status) {
      case FlagsStatus.FAILED:
        return { bg: "bg-red-100", dot: "bg-red-500" };
      case FlagsStatus.LOADING:
        return { bg: "bg-yellow-100", dot: "bg-yellow-500" };
      default:
        return { bg: "bg-green-100", dot: "bg-green-500" };
    }
  };

  const statusColor = getStatusColor();

  return (
    <div>
      <div
        className={`flex items-center justify-between p-2 ${statusColor.bg}`}
      >
        <div className="flex items-center space-x-2">
          <div className={`w-3 h-3 rounded-full ${statusColor.dot}`} />
          <span className="font-medium text-sm pr-1">
            Feature Flags ({status}) - {flagValues.size} loaded
          </span>
        </div>
      </div>

      <div className="overflow-auto">
        {flagValues.size > 0 ? (
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left p-2 font-medium">Flag Key</th>
                <th className="text-left p-2 font-medium">Value</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {Array.from(flagValues.entries()).map(([key, value]) => (
                <tr key={key} className="hover:bg-gray-50">
                  <td className="p-2 font-mono text-xs" title={key}>
                    {key}
                  </td>
                  <td
                    className="p-2 font-mono text-xs"
                    title={
                      typeof value === "object"
                        ? JSON.stringify(value)
                        : String(value)
                    }
                  >
                    {formatValue(value)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="text-center py-8 text-gray-500">
            {status === FlagsStatus.LOADING
              ? "Loading feature flags..."
              : "No feature flags available"}
          </div>
        )}
      </div>
    </div>
  );
}
